var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 14.1667C10.2361 14.1667 10.4342 14.0867 10.5942 13.9267C10.7542 13.7667 10.8339 13.5689 10.8333 13.3333C10.8333 13.0972 10.7533 12.8994 10.5933 12.74C10.4333 12.5806 10.2356 12.5006 10 12.5C9.76389 12.5 9.56611 12.58 9.40667 12.74C9.24722 12.9 9.16722 13.0978 9.16667 13.3333C9.16667 13.5694 9.24667 13.7675 9.40667 13.9275C9.56667 14.0875 9.76444 14.1672 10 14.1667ZM9.16667 10.8333H10.8333V5.83333H9.16667V10.8333ZM6.875 17.5L2.5 13.125V6.875L6.875 2.5H13.125L17.5 6.875V13.125L13.125 17.5H6.875Z",
    fill: "#EB4343"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamReport);
export default __webpack_public_path__ + "static/media/exam_report.196d502196ac98bb4047271b9d349245.svg";
export { ForwardRef as ReactComponent };